export function isLogin(): boolean {
  const authToken = localStorage.getItem("token");
  return (authToken && authToken !== "") || false;
}

export function saveToken(token: string): void {
  localStorage.setItem("token", token);
}

export function deleteToken(): void {
  localStorage.removeItem("token");
}

export enum Roles {
  "coach" = "coach",
  "clinician" = "clinician",
  "admin" = "admin",
  "superAdmin" = "superAdmin",
  "orgAdmin" = "orgAdmin"
}

const roleOrder = [Roles.coach, Roles.clinician, Roles.orgAdmin, Roles.admin, Roles.superAdmin];

export function isAllowed(requirement: Roles, role?: Roles): boolean {
  if (!role) {
    return false;
  }

  return roleOrder.indexOf(role) >= roleOrder.indexOf(requirement);
}
